import cookies, { CookieAttributes } from 'js-cookie'

export const getCookie = (name: string) => {
    if (typeof window === 'undefined') return
    return cookies.get(name)
}

export const setCookie = (
    name: string,
    value: string,
    cookieAttributes?: CookieAttributes,
) => {
    cookies.set(name, value, {
        domain: 'myfreecams.com',
        ...(cookieAttributes ? cookieAttributes : {}),
    })
}

export const eraseCookie = (name: string) => {
    cookies.remove(name, { domain: 'myfreecams.com' })
}
